import { create } from 'zustand';

import { Workbook } from '@/types/workbook.type';

export interface WorkbookState {
  workbook: Workbook | undefined;
  setWorkbook: (workbook: Workbook) => void;
}

export const useWorkbookStore = create<WorkbookState>((set) => ({
  workbook: undefined,
  setWorkbook: (workbook: Workbook) => set(() => ({ workbook })),
}));
